const getEditableDocumentType = (type) => {
  if (type === 'application/pdf' || type === 'pdf' || type === 'fax') return 'pdf';

  if (type === 'image/jpeg' || type === 'image/png' || type === 'image' || type === 'image/jpg')
    return 'image';
};

export default getEditableDocumentType;
